export default function Footer() {
  const year = new Date().getFullYear();

  const navLinks = [
    { label: '소개', href: '#about' },
    { label: '서비스', href: '#services' },
    { label: '문의', href: '#contact' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-[#111] py-10 px-10 md:px-20">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center h-7">
            <img
              src="https://static.readdy.ai/image/7e3352e848b93c3eb9a2ea481cb871cb/513bb4a137418228aa54dc71c4f368f7.png"
              alt="Studio Dissolve"
              className="h-7 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1) opacity(0.5)' }}
            />
          </div>

          {/* Nav Links */}
          <nav className="flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="font-sans-kr text-[11px] tracking-[0.2em] uppercase text-white/40 hover:text-white/70 transition-all duration-400 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Email + Copyright */}
          <div className="flex flex-col items-end gap-1.5">
            <a
              href="mailto:hello@dslv.kr"
              className="font-sans-kr text-xs text-white/40 hover:text-white/60 transition-all duration-400 cursor-pointer"
            >
              hello@dslv.kr
            </a>
            <p className="font-sans-kr text-[10px] text-white/20 tracking-wide">
              &copy; {year} Studio Dissolve. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
